var map = {
	"./de/general5/slide2.svg": 488113,
	"./en/general5/slide2.svg": 319381,
	"./es/general5/slide2.svg": 537160,
	"./fr/general5/slide2.svg": 693888,
	"./nl/general5/slide2.svg": 528742,
	"./pt/general5/slide2.svg": 274164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154601;